export enum SystemOfMeasurement {
  metric, US
}

export default SystemOfMeasurement;
